export default {
    browser_title: "Kevi | Respuestas",
    page_title: "Respuestas",
    messages_counter: "{0} de {1} respuestas",
    empty_state: "No se encontraron respuestas.",
    filters: {
        period: "Período",
        client_segments: "Segmento del cliente",
        automations: "Automatización",
        read_state: "Estado de lectura",
        select_read_state: "Leídas y no leídas",
        unread: "No leídas",
        read: "Leídas",
        tags: "Tag",
    },
    unread: "No leída",
    mark_read: "Marcar como leída",
    mark_all_read: "Marcar todas como leídas",
    type_emotion: "Emoción",
    type_nps: "NPS",
    type_ces: "CES",
    type_boolean: "Sí/No",
    type_comment: "Comentario",
    type_input: "Texto",
    type_selectbox: "Selección",
    type_date: "Fecha",
    type_file: "Archivo",
    type_table: "Tabla",
    notification_all_read: "Todas las respuestas fueron marcadas como leídas",
    notification_marked_read: "Respuesta marcada como leída",
    notification_marked_unread: "Respuesta marcada como no leída",
    notification_read_failed: "No se pudo actualizar el estado de lectura",
    message: {
        back: "Volver",
        confirm_delete_title: "¿Estás seguro de que deseas eliminar esta anotación?",
        confirm_delete_body: "Esta acción no se puede deshacer.",
        form_label: "Formulario",
        form_title: "Formulario {0}",
        filled_on: "Completado el",
        answers_report_title: "Reporte de Respuestas",
        answers_title: "Respuestas",
        purchases_label: "Compras",
        phone_label: "Teléfono",
        email_label: "Email",
        external_id_label: "ID externo",
        last_purchase_label: "Última compra",
        not_informed: "No informado",
        spend_summary: "R$ {0} gastados en {1} pedidos",
        no_purchase_data: "No hay datos de compras",
        mark_unread: "Marcar como no leída",
        view_client: "Ver cliente",
        more_actions: "Más acciones",
        edit_answers: "Editar respuestas",
        duplicate_answer: "Duplicar respuesta",
        print_answer: "Imprimir / guardar PDF",
        print_client: "Cliente",
        print_email: "Correo",
        print_phone: "Teléfono",
        print_answered_at: "Respondido el",
        print_answer_id: "Respuesta",
        print_footer: "Generado por Kevi",
        print_blocked: "El navegador bloqueó la ventana de impresión. Permite ventanas emergentes para Kevi e inténtalo de nuevo.",
        delete_answer: "Eliminar respuesta",
        create_task: "Crear tarea",
        create_task_title: "Crear tarea a partir de la respuesta",
        create_task_name: "Título",
        create_task_name_placeholder: "Título de la tarea",
        create_task_board: "Tablero",
        create_task_board_placeholder: "Ninguno (opcional)",
        create_task_stage: "Etapa",
        create_task_stage_placeholder: "Seleccione la etapa",
        create_task_assignee: "Responsable",
        create_task_assignee_placeholder: "Seleccione el responsable",
        create_task_due_date: "Fecha límite",
        create_task_description: "Descripción",
        create_task_action: "Crear tarea",
        create_task_default_title: "Nueva tarea",
        create_task_default_description: "Cliente: {0}",
        confirm_delete_answer_title: "¿Eliminar esta respuesta?",
        confirm_delete_answer_body:
            "La respuesta se ocultará del listado. Solo el soporte puede restaurarla.",
        edit_modal_title: "Editar respuestas",
        duplicate_modal_title: "Duplicar respuesta",
        edit_save: "Guardar cambios",
        duplicate_save: "Duplicar y guardar",
        notification_duplicated: "Respuesta duplicada con éxito",
        notification_duplicate_error: "No se pudo duplicar la respuesta",
        notification_deleted: "Respuesta eliminada",
        notification_delete_error: "No se pudo eliminar la respuesta",
        notification_edited: "Respuestas actualizadas",
        notification_edit_error: "No se pudieron guardar los cambios",
        notification_task_created: "Tarea creada con éxito",
        notification_task_create_error: "No se pudo crear la tarea",
        tags_label: "Tags",
        add_tag: "Agregar tag",
        tag_placeholder: "Selecciona una etiqueta o escribe",
        create_tag: "Crear",
        tag_empty: "Aún no hay tags. Escribe para crear una.",
        edit_tag: "Editar tag",
        select_tag_color: "Selecciona un color",
        delete_tag: "Eliminar",
        no_tags_available: "Ninguna tag configurada para este formulario",
        notification_tag_applied: "Tag aplicada",
        notification_tag_removed: "Tag eliminada",
        notification_tag_error: "No se pudo actualizar la tag",
        bool_yes: "Sí",
        bool_no: "No",
        unanswered: "Sin respuesta",
        no_files: "Ningún archivo enviado",
        remove_file: "Quitar",
        upload_files: "Agregar archivos",
        uploading_files: "Enviando...",
        upload_files_error: "No se pudo enviar el archivo",
        upload_files_too_many: "Puedes adjuntar como máximo {0} archivos",
        nps_promoter: "Promotor",
        nps_neutral: "Neutro",
        nps_detractor: "Detractor",
        ces_easy: "Fácil",
        ces_medium: "Aceptable",
        ces_hard: "Difícil",
        linked_tasks_title: "Tareas vinculadas",
        linked_task_open: "Abierta",
        linked_task_unassigned: "Sin responsable",
        notes_title: "Comentarios",
        edit_note: "Editar comentario",
        delete_note: "Eliminar comentario",
        save: "Guardar",
        cancel: "Cancelar",
        note_placeholder:
            "Escriba aquí lo que hizo o planea hacer con respecto a este feedback",
        add_note: "Comentar",
        notification_note_saved: "Comentario guardado con éxito",
        notification_note_empty: "La anotación no puede estar vacía",
        notification_note_updated: "Comentario actualizado con éxito",
        notification_note_update_error: "Error al actualizar la anotación",
        notification_note_deleted: "Comentario eliminado con éxito",
        notification_note_delete_error: "Error al eliminar la anotación",
        table_show_all: "Ver las {0} filas",
        table_show_less: "Ver menos",
        table_copy: "Copiar como planilla",
        table_copied: "Copiado",
        table_edit_unavailable: "Esta tabla no se puede editar aquí porque no fue respondida.",
    },
};
